import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, ComponentSync, LL_H_C, ModuleFE_MouseInteractivity, mouseInteractivity_PopUp, openContent } from '@nu-art/thunderstorm-frontend/index';
import './Component_FocusedProtocolInfo.scss';
import { PopUp_ProtocolDetails } from '../../../pop-ups/PopUp_ProtocolDetails/PopUp_ProtocolDetails.js';
import { BadImplementationException } from '@nu-art/ts-common';
import { ModuleFE_AdvisorBoard } from '../../../../_enum.js';
import { ColumnKey_RightColumn } from '../../../../_shared.js';
import { pathwayType_SingleState } from '@app/pathway-shared';
import { PopUp_ProtocolGoTo } from '../../../pop-ups/PopUp_ProtocolGoTo/PopUp_ProtocolGoTo.js';
import { ModuleFE_EMInterface } from '@app/advisor-frontend';
import { ModuleFE_ProvideInfo } from '../../../../modules/provide-info/ModuleFE_ProvideInfo.js';
import { Component_ProtocolGraph } from '../working-diagnosis/Component_ProtocolGraph/Component_ProtocolGraph.js';
export class Component_FocusedProtocolInfo extends ComponentSync {
    //######################### Life Cycle ##########################
    //This component is responsible for listening on board changes and closing the details if
    //the next steps panel is closed up.
    __onAdvisorBoardUpdated = (updates) => {
        if (!updates.includes(ColumnKey_RightColumn))
            return;
        const width = ModuleFE_AdvisorBoard.getColumnWidth(ColumnKey_RightColumn);
        if (width === 0)
            this.setState({ showDetails: false }, () => ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp));
    };
    deriveStateFromProps(nextProps, state) {
        state.protocolData = nextProps.protocolData;
        state.showDetails ??= false;
        return state;
    }
    //######################### Logic ##########################
    toggleDetails = (e) => {
        if (this.state.showDetails)
            return this.setState({ showDetails: false }, () => {
                ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
            });
        if (!e)
            throw new BadImplementationException('Can\'t open pop up without event');
        this.setState({ showDetails: true }, () => PopUp_ProtocolDetails.show(e, {
            closeDetails: this.toggleDetails,
            protocolData: this.state.protocolData,
        }));
    };
    openGoTo = (e) => {
        PopUp_ProtocolGoTo.show(e, { protocolData: this.state.protocolData });
    };
    //######################### Render ##########################
    render() {
        return _jsxs("div", { className: 'focused-protocol-info', children: [this.render_Graph(), this.render_Actions()] });
    }
    render_Graph = () => {
        const pathwayType = this.state.protocolData.pathway.type;
        if (pathwayType === pathwayType_SingleState)
            return _jsx("div", { className: 'focused-protocol-info__no-protocol', children: "This DDX has no designated protocol" });
        const context = ModuleFE_ProvideInfo.getCurrentProtocolContextData();
        if (!context)
            return;
        return _jsx(Component_ProtocolGraph, { context: context });
    };
    render_Actions = () => {
        return _jsxs(LL_H_C, { className: 'focused-protocol-info__actions', children: [this.render_DetailsButton(), this.render_GoToButton()] });
    };
    render_GoToButton = () => {
        if (ModuleFE_EMInterface.isAvatarMode() || ModuleFE_EMInterface.isPostDisposition())
            return;
        return _jsx(Button, { variant: 'header-button', onClick: this.openGoTo, ...openContent.tooltip.top('tooltip__go-to', _jsx(_Fragment, { children: "Use this button or double-click on the state to jump to a specific state" }), { offset: 8 }), children: "Go To" });
    };
    render_DetailsButton = () => {
        const className = _className(this.state.showDetails && 'active');
        return _jsx(Button, { variant: 'header-button', className: className, onClick: this.toggleDetails, children: "Reasoning" });
    };
}
//# sourceMappingURL=Component_FocusedProtocolInfo.js.map